var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { Translate } from "../../../I18N";









const CopyValueInput = ({ value, className, label, id, hideLabel }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [copied]);

  return /*#__PURE__*/(
    _jsx("div", { className: `${className}` }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: id, className: hideLabel ? 'sr-only' : '' }, void 0,
    label
    ), /*#__PURE__*/
    _jsx("div", { className: "relative w-full" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      disabled: true,
      value: value,
      id: id,
      className: "disabled:text-gray-500 rounded-lg bg-gray-50 block flex-1 w-full text-sm p-2.5" }
    ), /*#__PURE__*/
    _jsx("div", { className: "flex absolute right-0 top-px items-center" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: copyToClipboard,
      "data-testid": "copy-value-button",
      className: "hover:text-primary-700 text-gray-900 p-2.5 text-sm font-medium rounded-r-lg focus:outline-none" }, void 0,


    copied ? /*#__PURE__*/
    _jsx(CheckIcon, { className: "w-5 text-success-600" }) : /*#__PURE__*/

    _jsx(ClipboardDocumentIcon, { className: "w-5" }), /*#__PURE__*/


    _jsx(Translate, { className: "sr-only" }, void 0, "Copy to clipboard")
    ),
    copied && /*#__PURE__*/
    _jsx("div", {
      role: "tooltip",
      className: "inline-block absolute right-0 -top-11 z-10 px-3 py-2 w-max text-sm font-medium bg-white rounded-lg border-gray-50 shadow-sm" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Copied to clipboard")
    )

    )
    )
    ));

};

export { CopyValueInput };